export const MAINTENANCE_WARNINGS_EVENTS_OPEN_MODAL = "MAINTENANCE_WARNINGS_EVENTS_OPEN_MODAL";